import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface AttendanceState {
  enrolledAthletesList: any[];
}

const initialState: AttendanceState = {
  enrolledAthletesList: [],
};

const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {
    setEnrolledAthletesList: (state, action) => {
      state.enrolledAthletesList = action.payload;
    },
  },
});

export const { setEnrolledAthletesList } = attendanceSlice.actions;

// <-- selector to “get” -->
export const selectEnrolledAthletesList = (state: RootState) =>
  state.attendance.enrolledAthletesList;

export default attendanceSlice.reducer;
